import { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import './MainDashboard.css'
import ProyectosList from './ProyectosList'
import DropdownSearch from './DropdownSearch'
import Searcher from './Searcher'
import ButtonNewProject from './ButtonNewProject'
import Filter from './Filter'
import FILTER_ITEMS from '../../utils/filterItems'

const MainDashboard = () => {
  const [searchParams, setSearchParams] = useSearchParams()

  const filterParam = searchParams.get('filter') || 'Activos'
  const sortParam = searchParams.get('sort') || 'createdAt-desc'

  const [filter, setFilter] = useState(
    () =>
      FILTER_ITEMS.find(item => item.name === filterParam) || FILTER_ITEMS[0]
  )

  const [sort, setSort] = useState(() => {
    const [field, order] = sortParam.split('-')
    return field ? { [field]: order === 'asc' ? 1 : -1 } : { name: 1 }
  })

  useEffect(() => {
    setFilter(
      FILTER_ITEMS.find(item => item.name === filterParam) || FILTER_ITEMS[0]
    )
  }, [filterParam])

  useEffect(() => {
    const [field, order] = sortParam.split('-')
    setSort(field ? { [field]: order === 'asc' ? 1 : -1 } : { name: 1 })
  }, [sortParam])

  const handleFilterChange = selectedFilter => {
    if (selectedFilter.name !== filter.name) {
      const params = new URLSearchParams(searchParams.toString())
      params.set('filter', selectedFilter.name)
      setSearchParams(params)
    }
  }

  const handleSortChange = newSort => {
    const sortKey = Object.keys(newSort)[0]
    const sortOrder = newSort[sortKey] === 1 ? 'asc' : 'desc'

    if (
      sortKey !== Object.keys(sort)[0] ||
      sortOrder !== (sort[sortKey] === 1 ? 'asc' : 'desc')
    ) {
      const params = new URLSearchParams(searchParams.toString())
      params.set('sort', `${sortKey}-${sortOrder}`)
      setSearchParams(params)
    }
  }

  return (
    <section className="section-projects">
      <div className="container">
        <div className="container-heading-title">
          <h1 className="heading-primary">Proyectos</h1>
        </div>
        <nav className="projects-nav">
          <div className="projects-nav-left">
            <div className="dropdown-searcher">
              <Searcher />
            </div>
            <div className="filters-flex">
              <div className="dropdown-div">
                <Filter
                  handleFilterChange={handleFilterChange}
                  filter={filter}
                />
              </div>
              <div className="dropdown-div">
                <DropdownSearch
                  sortValue={sort}
                  onChangeSort={handleSortChange}
                />
              </div>
            </div>
          </div>
          <ButtonNewProject />
        </nav>

        <ProyectosList disabled={filter?.value ?? ''} sort={sort} />
      </div>
    </section>
  )
}

export default MainDashboard
